import styles from './SuccessStory.module.css';

export default function SuccessStory({ imgSrc, title, description }) {
    
    return (
        <div className={styles.successStoryContainer}>
            {imgSrc && (
                <img src={imgSrc} alt={title} className={styles.storyImage} />
            )}
            <div className={styles.storyTextContainer}>
                <h3 className={styles.storyTitle}>{title}</h3>
                <div className={styles.storyDescription}>{description}</div>
            </div>
        </div>
    );
}